// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .legendContent tr > td:first-of-type {
  display: flex;
  align-items: flex-start;
}
:host ::ng-deep .legendContent tr > td:first-of-type img {
  width: 40px !important;
  max-width: none !important;
}

:host ::ng-deep .legendContent tr > td {
  vertical-align: top;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
